import { enqueueSnackbar, DownloadFile } from 'actions';

import {
	GetTeamAssignRequest, GetTeamAssignDetailsRequest, SaveTeamAssignRequest, ResetTeamAssignRequest
} from '../requests/ManagementRequest';

export const SET_FORM_STATE_ERICSSON = 'SET_FORM_STATE_ERICSSON';
export const SET_FORM_STATE_NOKIA = 'SET_FORM_STATE_NOKIA';
export const SET_FORM_STATE_VALUES = 'SET_FORM_STATE_VALUES';

const onSetFormStateEricsson = (value) => ({
	type: SET_FORM_STATE_ERICSSON,
	formStateEricsson: value
});

export const SetFormStateEricsson = (value) => (dispatch) => {
	dispatch(onSetFormStateEricsson(value));
};

const onSetFormStateNokia = (value) => ({
	type: SET_FORM_STATE_NOKIA,
	formStateNokia: value
});

export const SetFormStateNokia = (value) => (dispatch) => {
	dispatch(onSetFormStateNokia(value));
};

const onGetTeamAssign = (value) => ({
	type: SET_FORM_STATE_VALUES,
	teamAssingValues: value
});

export const GetTeamAssign = (userId) => async (dispatch) => {
	await GetTeamAssignRequest(userId).then(response => {
		dispatch(onGetTeamAssign(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SET_DETAILS = 'SET_DETAILS';

const onGetTeamAssignDetails = (value) => ({
	type: SET_DETAILS,
	teamDetails: value
});

export const GetTeamAssignDetails = (userId) => async (dispatch) => {
	await GetTeamAssignDetailsRequest(userId).then(response => {
		dispatch(onGetTeamAssignDetails(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

// BUTTONS ACTIONS

export const SaveAllocation = (allocationUpdate) => async (dispatch) => {
	await SaveTeamAssignRequest(allocationUpdate).then(response => {
		// statusCode 201 = Created
		if (response.status === 201) {
			dispatch(GetTeamAssign(allocationUpdate.UserId));
			dispatch(GetTeamAssignDetails(allocationUpdate.UserId));
			dispatch(enqueueSnackbar({ message: 'Saved', options: { variant: 'success' } }));
		} else {
			dispatch(enqueueSnackbar({ message: response.statusText, options: { variant: 'error' } }));
		}
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ResetAllocation = (userId, id) => async (dispatch) => {
	await ResetTeamAssignRequest(userId, id).then(response => {
		// statusCode 201 = Created
		if (response.status === 201) {
			dispatch(GetTeamAssign(userId));
			dispatch(GetTeamAssignDetails(userId));
			dispatch(enqueueSnackbar({ message: 'Resetting completed', options: { variant: 'success' } }));
		} else {
			dispatch(enqueueSnackbar({ message: response.statusText, options: { variant: 'error' } }));
		}
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
